import React from 'react';

import { AtlassianAnalyticsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <AtlassianAnalyticsIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useAnalytics = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ANALYTICS,
		analyticsName: Products.ANALYTICS,
		...options,
	});
